
import NetworkLogic from "../Shared/NetworkLogic";
import Utils from "../Shared/Utils";
import UIManager from "../Shared/UIManager";
import {Global} from "../Shared/Global";
import AudioManager from "../Shared/AudioManager";
import Player from "../Models/Player";
import SDKManager from "../Shared/SDKManager";
import Constant from "../Shared/Constant";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LoginQuickRegister extends cc.Component {

    @property(cc.EditBox)
    edUserId : cc.EditBox = null;
    @property(cc.EditBox)
    edPassword : cc.EditBox = null;

    @property(cc.Node)
    nodeEditBtn1 : cc.Node = null;
    @property(cc.Node)
    nodeEditBtn2 : cc.Node = null;
    @property(cc.Node)
    nodeCheckBtn1 : cc.Node = null;
    @property(cc.Node)
    nodeCheckBtn2 : cc.Node = null;
    @property(cc.Node)
    nodeSaveImage : cc.Node = null;

    @property(cc.Label)
    userId1 : cc.Label = null;
    @property(cc.Label)
    password1 : cc.Label = null;

    @property(cc.Node)
    nodeBtnOk: cc.Node = null;
    @property(cc.Node)
    nodeBtnSave: cc.Node = null;
    @property(cc.Label)
    lbAppName: cc.Label = null;

    check1 = true;
    check2 = true;

    private _channelCode: string = ""
    private _bindData: {} = null

    onLoad () {
        this.lbAppName.string = Constant.PackageName
    }

    start () {
        this.getInstallParms()
    }

    updateUI(rec){
        this.edUserId.string = rec.userId;
        this.edPassword.string = rec.password;
    }



    onBtnEdit1(){
        AudioManager.playSound("button");
        this.edUserId.enabled = true;
        this.nodeEditBtn1.active = false;
        this.nodeCheckBtn1.active = true;

        this.check1 = false;
    }

    onBtnEdit2(){
        AudioManager.playSound("button");
        this.edPassword.enabled = true;
        this.nodeEditBtn2.active = false;
        this.nodeCheckBtn2.active = true;

        this.check2 = false;
    }

    onBtnCheck1(){
        AudioManager.playSound("button");
        let data = {
            "userId" : this.edUserId.string,
            "pwd" : this.edPassword.string
        }
        NetworkLogic.loginVisitorVerification(data,function(rec){
            cc.log("===修该账号成功",rec);
            this.edUserId.enabled = false;
            this.check1 = true;
            this.nodeCheckBtn1.active = false;

        }.bind(this),function () {
            cc.log("===失败原因呢");//肯能是账号重复之类对
        });
    }

    onBtnCheck2(){
        AudioManager.playSound("button");
        this.edPassword.enabled = true;
        let data = {
            "userId" : this.edUserId.string,
            "pwd" : this.edPassword.string
        }
        NetworkLogic.loginVisitorVerification(data,function(rec){
            cc.log("===修改密码成功",rec);
            this.edPassword.enabled = false;
            this.check2 = true;
            this.nodeCheckBtn2.active = false;
        }.bind(this),function () {
            cc.log("===失败原因呢");//肯能是账号重复之类对
        });
    }

    onBtnOk(){
        AudioManager.playSound("button");
        if (!this.check1 || !this.check2){
            UIManager.showToastUI("请先点击打勾按钮确认账号密码！",Global.ToastType.Warnning)
            return;
        }
        cc.log("====设备号：",Utils.getDeviceId());
        //cc.log("====设备型号：",jsb.device.getDeviceModel());
        this.userId1.string = this.edUserId.string;
        this.password1.string = this.edPassword.string;
        let data = {
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": this._channelCode,
            "parentAgentCode": this._bindData ? this._bindData["code"] : "",
            "pwd": this.edPassword.string,
            "userId": this.edUserId.string,
        }
        UIManager.showLoadingUI()
        NetworkLogic.loginVisitorRegistered(data,function(rec){
            UIManager.hideLoadingUI()
            cc.log("===注册成功",rec);
            if (Constant.InstallSDK === 0) {
                SDKManager.reportRegister()
            }else if (Constant.InstallSDK === 1) {
                SDKManager.shareInstallReportRegister()
            }
            this.nodeBtnOk.active = false;
            this.nodeBtnSave.active = true;

            Player.setPy("token", rec.token)
            cc.log("====注册成功之后token：",Player.getPy("token"));
            //cc.sys.localStorage.setItem(Global.localStorageId.QuickLoginUserId, this.edUserId.string);
        }.bind(this),function () {
            UIManager.hideLoadingUI()
            cc.log("===loginVisitorRegistered失败原因呢");//肯能是账号重复之类对
            this.node.destroy();
        }.bind(this));
    }

    onBtnSave(){
        AudioManager.playSound("button");
        Utils.saveNodeImageToAlbum(this.nodeSaveImage, "userIdAndPassword" + ".png", function (success) {
            if (success) {
                UIManager.showToastUI("保存成功！", Global.ToastType.OK);
                cc.director.emit(Global.UserEvent.AfterLogin);//登陆之后
                this.node.destroy();

            } else {
                UIManager.showTipUI("保存失败！",Global.ToastType.Error)

            }
        }.bind(this));
    }

    onBtnClose(){
        AudioManager.playSound("close");
        this.node.destroy();
    }

    private getInstallParms() {
        if (!cc.sys.isMobile) return
        if (cc.sys.os === cc.sys.OS_IOS) {
            let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
            if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                this._channelCode = nativeChannel;
            }
        } else if (cc.sys.os === cc.sys.OS_ANDROID) {
            let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
            if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                this._channelCode = nativeChannel;
            }
        }
        if (Constant.InstallSDK === 0) {
            SDKManager.getInstallParms(function (data) {
                cc.log("install parms:" + (data ? JSON.stringify(data) : ""))
                // 从openinstall 获取了一次了
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = (data && data["bindData"]) ? JSON.parse(data["bindData"]) : {}
            }.bind(this))
        }else if (Constant.InstallSDK === 1) {
            SDKManager.getShareInstallParm(function (data) {
                cc.log("install parms:" + (data ? JSON.stringify(data) : ""))
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = {"code": (data && data["code"]) ? data["code"] : ""}
            }.bind(this))
        }else if (Constant.InstallSDK === 2) {
            SDKManager.getShareTraceParm(function (data) {
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = {"code": (data && data["code"]) ? data["code"] : ""}
                // UIManager.showTipUI(JSON.stringify(data))
            }.bind(this))
        }
    }
}
